import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import IonIcons from '@expo/vector-icons/Ionicons';
import PropTypes from 'prop-types';
import Colors from '../constants/Colors';

/**
 * Full-width navigation bar for the top of the viewport. Displays the
 * current screen title and optionally a back button.
 */
export default function NavBar(props) {
  return (
    <View style={styles.container}>
      {props.onPressBack && (
        <TouchableOpacity onPress={props.onPressBack} style={styles.backButton}>
          <IonIcons name="arrow-back-outline" size={24} style={styles.backIcon} />
        </TouchableOpacity>
      )}
      <Text style={styles.title}>{props.title}</Text>
    </View>
  );
}

NavBar.propTypes = {
  title: PropTypes.string.isRequired,
  onPressBack: PropTypes.func,
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    borderBottomColor: Colors.grayBorder,
    backgroundColor: Colors.white,
    borderBottomWidth: 1,
    paddingVertical: 16,
  },
  backButton: {
    padding: 16,
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 1,
  },
  backIcon: {
    color: Colors.mediumBlue,
  },
  title: {
    textAlign: 'center',
    fontSize: 20,
    color: Colors.mediumBlue,
    fontWeight: 'bold',
    width: '100%',
  },
});
